export default "__VITE_ASSET__Dahbzj7j__"